import { initials } from '@/lib/string'

export type Size = 'xs' | 'sm' | 'xxsmd' | 'xsmd' | 'md' | 'lg' | 'xl' | 'xxl'

export interface Props {
  src?: string
  outlined?: boolean
  size: Size
  alt?: string
  attention?: boolean
  className?: string
  title?: string
  border?: boolean
}

const Avatar = ({
  size,
  src,
  outlined,
  attention,
  alt = 'Avatar',
  className = '',
  title,
  border = false,
}: Props): JSX.Element => {
  const sizeClasses = {
    xs: 'h-5 w-5 text-[10px]',
    sm: 'h-8 w-8 text-xs',
    xxsmd: 'h-14 w-14 text-2xl',
    xsmd: 'h-16 w-16 text-2xl',
    md: 'h-30 w-30 text-2xl',
    lg: 'h-45 w-45 text-5xl',
    xl: 'h-28 w-28 text-2xl',
    xxl: 'h-20 w-20 text-[32px]',
  }

  const classes = [
    'inline-block relative rounded-full overflow-hidden align-middle bg-gray-200',
    outlined ? 'border border-[#f9f5ef]' : '',
    attention ? 'border-secondary' : '',
    border ? 'border-[6px] border-[#f9f5ef]' : '',
    sizeClasses[size],
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} data-testid="avatar">
      {src ? (
        <img
          src={src}
          alt={`${title} ${alt ?? ''}`}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        initials(title ?? '')
      )}
    </span>
  )
}

export default Avatar
